import './src/style/vendor/bootstrap-lite.scss';
import './src/style/main.scss';
import { getLanguageFromPath } from './src/utils/languages';
import { setAnalyticsUserProperties } from './src/utils/analytics';
import { listenForInstallPrompt } from './src/utils/installPrompt';

export const onClientEntry = () => {
  listenForInstallPrompt(window);
};

export const onRouteUpdate = ({ location }) => {
  setAnalyticsUserProperties({
    locale: getLanguageFromPath(location.pathname),
  });
};